/**
 * slider-drag.js — click-and-hold horizontal drag for Dawn's
 * <slider-component>. Touch is untouched (native overflow scroll);
 * only mouse interactions get the drag enhancement.
 *
 * Key design choice — capture is *deferred* until a real drag is
 * detected (cursor moves > 5 px). Pure clicks never trigger
 * setPointerCapture, so the click event reaches the underlying
 * anchor and navigation works normally. Once a drag is confirmed
 * we then capture so the release fires reliably even off-screen.
 */

(function () {
  'use strict';

  var DRAG_THRESHOLD_PX = 5;

  function enhance(sliderComponent) {
    var rail = sliderComponent.querySelector('[id^="Slider-"]');
    if (!rail) return;

    rail.style.cursor = 'grab';
    rail.style.userSelect = 'none';

    // Browser's native image-drag would hijack pointer events when
    // mousedown starts on a product image — suppress it.
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScrollLeft = 0;
    var activePointerId = null;
    var captured = false;

    var originalSnap = '';
    var originalBehavior = '';
    var snapDisabled = false;

    function disableSnap() {
      if (snapDisabled) return;
      originalSnap     = rail.style.scrollSnapType;
      originalBehavior = rail.style.scrollBehavior;
      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';
      snapDisabled = true;
    }
    function restoreSnap() {
      if (!snapDisabled) return;
      rail.style.scrollSnapType = originalSnap;
      rail.style.scrollBehavior = originalBehavior;
      snapDisabled = false;
    }

    function release() {
      if (!isDown) return;
      isDown = false;
      rail.style.cursor = 'grab';
      restoreSnap();
      if (captured && activePointerId !== null) {
        try { rail.releasePointerCapture(activePointerId); } catch (e) {}
      }
      captured = false;
      activePointerId = null;
    }

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;   // touch keeps native scroll
      if (e.button !== 0) return;              // left-button only

      isDown = true;
      dragged = false;
      captured = false;
      startX = e.clientX;
      startScrollLeft = rail.scrollLeft;
      activePointerId = e.pointerId;
      // NOTE: we deliberately do NOT setPointerCapture here. If the
      // user releases without moving, the browser dispatches a normal
      // click event to the underlying element (a product link) so
      // navigation works.
    });

    rail.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== activePointerId) return;
      var walk = e.clientX - startX;
      if (!dragged && Math.abs(walk) > DRAG_THRESHOLD_PX) {
        dragged = true;
        rail.style.cursor = 'grabbing';
        disableSnap();
        // Now that this is a real drag, capture the pointer so move/up
        // fire reliably even off-screen.
        try {
          rail.setPointerCapture(e.pointerId);
          captured = true;
        } catch (err) {}
      }
      if (dragged) {
        e.preventDefault();
        rail.scrollLeft = startScrollLeft - walk;
      }
    });

    rail.addEventListener('pointerup',     release);
    rail.addEventListener('pointercancel', release);

    // Suppress the click that fires after a drag, so dragging through
    // a product card doesn't navigate. Pure clicks never set
    // `dragged = true`, so they pass through.
    rail.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
